import { defineComponent as n, openBlock as r, createBlock as l, unref as a, mergeProps as p, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as f } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconChevronLeft",
  __name: "IconChevronLeft",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (i, e) => (r(), l(a(f), p(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", {
          "fill-rule": "evenodd",
          d: "m10.957 12 3.47-3.47a.75.75 0 1 0-1.06-1.06L9.72 11.116a1.25 1.25 0 0 0 0 1.768l3.646 3.646a.75.75 0 0 0 1.06-1.06L10.958 12",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
